// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__Tul-v","wrapper":"styles_wrapper__vkrZg","text":"styles_text__0PBhV"};